export const getSFUValues = (state) => {
	return state.Filters.sfuValues || {};
};
